import { useEffect, useState, useCallback, useContext } from "react";
import { useSnackbar } from "notistack";
import { Grid } from "@mui/material";
import { useStyles } from "./styles";
import SummaryCard from "../../components/SummaryCard/SummaryCard";
import InvoiceTable from "../../components/InvoiceTable/InvoiceTable";
import httpRequest from "../../httpRequest";
import AppLayout from "../../components/AppLayout/AppLayout";
import UserContext from "../../context/user-context"; // Import UserContext

const MyInvoices = () => {
  const classes = useStyles();
  const [selectedInvoice, setSelectedInvoice] = useState({});
  const [invoicesData, setInvoicesData] = useState([]);
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  // Access the UserContext
  const userCtx = useContext(UserContext);
  const { overriddenRole, employeeData, userId } = userCtx; // Extract relevant data from context

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [invoicesResp] = await Promise.all([
        httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-invoices?exclude_fields=pdf_file,image_file`),
      ]);

      setInvoicesData(invoicesResp.data.invoices);
    } catch (error) {
      console.error("Error fetching data:", error);
      enqueueSnackbar("Error fetching data", { variant: "error" });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar]);

  const handleBackButtonClick = () => {
    setIsSummaryOpen(false);
    fetchData();
  };

  const openSummary = (invoiceData) => {
    setIsSummaryOpen(true);
    setSelectedInvoice(invoiceData);
  };

  const handleDataChange = () => {
    fetchData();
  };

 // Filter invoices based on user permissions, status, companies, and functions
const filteredInvoices = invoicesData.filter((invoice) => {
  // Check if it belongs to that employee
  const isEmployeeMatch = 
    invoice.employee_code === employeeData.employee_code ||
    invoice.standing_employee_code === employeeData.employee_code ||
    (invoice.approval_flow && invoice.approval_flow.some(flow => flow.includes(userId)));

  // Filter out invoices with status 'Cancelled'
  const isStatusValid = invoice.status !== 'Cancelled';

  return isEmployeeMatch && isStatusValid; // Combine both conditions
});


  // useEffect to fetch data on mount
  useEffect(() => {
    fetchData(); // Call fetchData on component mount
  }, [fetchData]); // Ensure the callback is stable

  return (
    <AppLayout>
      <Grid container>
        {!isSummaryOpen && (
          <div className={classes.table}>
            <InvoiceTable
              invoiceData={filteredInvoices}
              openSummary={openSummary}
              refreshInvoiceData={fetchData} // Pass fetchData to refresh invoices
              loading={loading}
            />
          </div>
        )}
      </Grid>
      {isSummaryOpen && (
        <div>
          <SummaryCard
            dataFromDB={selectedInvoice}
            dataChanged={handleDataChange}
            onBackButtonClick={handleBackButtonClick}
          />
        </div>
      )}
    </AppLayout>
  );
};

export default MyInvoices;
